<div class="session_template">
    <div class="dialoag_body_">
        <div class="timerImage">
            <img src="../../../assets/belairtrip_assets/svg_icon/sessionTimeOut.svg" alt="Session Time-Out" class="img-fluid">
        </div>
        <div class="content_">
            <h3 mat-dialog-title>Still there? Session has Timed Out</h3>
            <div class="refresh_Btn">
                <button mat-ripple-loader color="primary" class="sessionBtn" (click)="startAfresh()">Start Afresh</button>
                <!-- <button mat-ripple-loader color="primary" class="sessionBtn" (click)="continue()">Continue</button> -->
            </div>
            <p>Hurry up and complete your booking, fares might change,<br>Fares may get affected.</p>
        </div>
    </div>
</div>
